"use client";

import React, { useEffect, useRef, useState } from "react";
import { Database, ShieldCheck, Send, Cpu, Code, Terminal } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const steps = [{
  id: "step-1",
  title: "Organismes de formation",
  description: "Accompagnement complet pour l'obtention et le maintien de la certification Qualiopi, optimisation des processus internes et mise en conformité réglementaire durable.",
  icon: Database,
  codeTitle: "audit_qualiopi.json",
  code: `{
  "audit_type": "Qualiopi_V7",
  "target": "Indicateurs_Majeurs",
  "mapping": {
    "critere_1": "Information_Public",
    "critere_2": "Objectifs_Prestations",
    "critere_3": "Adaptation_Public",
    "critere_6": "Inscription_Environnement"
  },
  "validation": "conforme"
}`
}, {
  id: "step-2",
  title: "Organismes certificateurs",
  description: "Ingénierie de certification pour le dépôt et le suivi de vos dossiers RNCP et Répertoire Spécifique auprès de France Compétences, garantissant la valeur de vos titres.",
  icon: ShieldCheck,
  codeTitle: "rncp_workflow.log",
  code: `> [INIT] Analyse dossier RNCP v4.0... OK
> [CHECK] Référentiel de compétences... VALIDÉ
> [CHECK] Référentiel d'évaluation... VALIDÉ
> [INFO] Adéquation emploi-formation : 98%
> [SUCCESS] Transmission France Compétences
> [READY] Session d'examen programmée`
}, {
  id: "step-3",
  title: "Consultants & Indépendants",
  description: "Soutien stratégique pour structurer votre offre de formation, gérer votre BPF et naviguer sereinement dans les méandres administratifs du secteur de la formation.",
  icon: Send,
  codeTitle: "ingenierie_pedago.ts",
  code: `async function creerSession(id: string, ctx: Context) {
  const formation = {
    titre: "Expertise Qualité",
    modalite: "Blended_Learning",
    duree: "14 heures",
    supports: ctx.digitalAssets
  };

  const bpf = await generateurBPF(ctx.data);
  
  if (bpf.status === 'ready') {
    return { success: true, declaration: bpf.id };
  }
}`
}];
export default function AutomationDeepDive() {
  const sectionRef = useRef<HTMLElement>(null);
  const [progress, setProgress] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const section = sectionRef.current;
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const startOffset = windowHeight * 0.2;
      const scrolled = scrollY - sectionTop + startOffset;
      const scrollableHeight = sectionHeight - windowHeight * 0.5;
      let newProgress = scrolled / scrollableHeight * 100;
      newProgress = Math.max(0, Math.min(100, newProgress));
      setProgress(newProgress);
      const stepThreshold = 100 / steps.length;
      const currentStep = Math.min(steps.length - 1, Math.floor(newProgress / stepThreshold));
      setActiveStep(currentStep);
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return;
}